import useAppStore from '@/store/app';
import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import useAllowedRoutes from '@/hooks/useAllowedRoutes';

const billingNavigationItems = [
  {
    title: 'Tanss',
    slug: 'services',
  },
  {
    title: 'Vertragswesen',
    slug: 'contracts-management',
    subitems: [
      {
        title: 'Verträge',
        slug: 'contracts',
      },
      {
        title: 'Eingangs-RE',
        slug: 'contracts/invoices',
      },
      {
        title: 'Eingangs-Posten',
        slug: 'contracts/sources',
      },
    ],
  },
];

export default function BillingLayout() {
  const { setNavigation } = useAppStore();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const allowedBillingRoutes = useAllowedRoutes(
    '/billing',
    billingNavigationItems,
  );

  useEffect(() => {
    setNavigation({
      base: '/billing',
      items: billingNavigationItems,
    });

    if (pathname === '/billing' && allowedBillingRoutes.length > 0) {
      const firstAllowedItem = allowedBillingRoutes[0];
      let redirectToSlug;
      if (firstAllowedItem.subitems && firstAllowedItem.subitems.length > 0) {
        redirectToSlug = firstAllowedItem.subitems[0].slug;
      } else {
        redirectToSlug = firstAllowedItem.slug;
      }
      if (redirectToSlug) {
        navigate(`/billing/${redirectToSlug}`, { replace: true });
      }
    }
  }, [pathname, setNavigation, navigate, allowedBillingRoutes]);

  return (
    <Box sx={{ display: 'flex', flex: 1, height: '100%' }}>
      <Box
        sx={{
          flexGrow: 1,
          backgroundColor: 'rgba(0, 0, 0, 0.01)',
          width: '100%',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
